import * as React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import FindInPageIcon from '@mui/icons-material/FindInPage'
import Document from './../../../assets/icons/document.png'

import UpArrow from './../../../assets/icons/arrowup.png'
import DownArrow from './../../../assets/icons/down-filled-triangular-arrow.png'
import { useEffect, useState } from 'react'
import { IconButton } from '@mui/material'
const columns = [
    { id: 'rank', label: 'Rank', minWidth: 100 },
    { id: 'name', label: 'Name', minWidth: 170 },
]

function createData(id, rank, name) {
    return { id, rank, name }
}
const RestaurantTable = (props) => {
    const [rows, setRows] = useState([
        createData(1, 1, 'Burger'),
        createData(2, 2, 'Pizza'),

    ])
    useEffect(() => {
        console.log(props);
        setRows([]);
        var list = [];
        if (props.from == "edit") {
            props.lists.map((dt, i) => {
                console.log(dt.text);
                list.push(createData(dt.id, i + 1, dt.text));
            })
        }
        else {
            props.lists.map((dt, i) => {
                console.log(dt.name);
                list.push(createData(i, i + 1, dt.name));
            })
        }

        setRows(list);
        props.getTypeWriterData(list);
    }, [])
    const handleRankChange = (index, action) => {
        const updatedRows = [...rows]
        const currentRow = updatedRows[index]
        let targetIndex

        if (action === 'increase' && index > 0) {
            targetIndex = index - 1
        } else if (action === 'decrease' && index < rows.length - 1) {
            targetIndex = index + 1
        } else {
            return
        }

        const targetRow = updatedRows[targetIndex]
        const currentRank = currentRow.rank
        const targetRank = targetRow.rank

        currentRow.rank = targetRank
        targetRow.rank = currentRank

        updatedRows[index] = targetRow
        updatedRows[targetIndex] = currentRow

        setRows(updatedRows)
        props.getTypeWriterData(updatedRows);
    }
    const editRow = (row) => {
        props.editData(row)
    }
    const deleteRow = (row) => {
        props.deleteRow(row)
    }
    return (
        <div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow >

                                {columns.map((column) => (
                                    <TableCell
                                        sx={{ backgroundColor: '#e2eaee' }}
                                        key={column.id}
                                        align="center"
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell
                                    sx={{ backgroundColor: '#e2eaee' }}
                                    key={"a"}
                                    align="center"
                                    style={{ minWidth: 170 }}
                                >
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>


                            {rows.map((row, index) => {
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.rank}
                                    >
                                        <TableCell align="center">
                                            <IconButton
                                                disabled={index === 0}
                                                onClick={() => handleRankChange(index, 'increase')}
                                            >
                                                <ArrowUpwardIcon />
                                            </IconButton>
                                            {row.rank}
                                            <IconButton
                                                disabled={index === rows.length - 1}
                                                onClick={() => handleRankChange(index, 'decrease')}
                                            >
                                                <ArrowDownwardIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell align="center">{row.name}</TableCell>
                                        <TableCell align="center">
                                            {
                                                props.from == "edit" ? (
                                                    <div className='d-flex justify-content-center align-items-center' style={{ gap: "10px" }}>
                                                        <span onClick={() => { editRow(row) }}>Edit</span>
                                                        <span onClick={() => { deleteRow(row) }}>Delete</span>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <span>Delete</span>
                                                    </div>
                                                )
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Paper>
        </div>
    );
};

export default RestaurantTable;